module.exports = __webpack_public_path__ + "img/sheep_des_4.9f4b1a87.jpg";